import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class IntegrityMonitoringValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    if (
      ProtectedEntitiesHelper.isUnifiedClient(record) &&
      (record.specifics.operatingSystem === Constants.ProtectedEntities.OS.PROTECTED_ENTITY_OS_WIN ||
        record.specifics.operatingSystem === Constants.ProtectedEntities.OS.PROTECTED_ENTITY_OS_NIX) &&
      record.specifics.hasIntegrityMonitor === true
    ) {
      return true;
    }

    return false;
  }
}
